// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert_title[data-v-8f82d0e2]{margin-left:20px;width:240px}", ""]);
// Exports
module.exports = exports;
